import { DishQuantityCounter } from "./DishQuantityCounter";

export default DishQuantityCounter;
